<div
  #alertErrorRef
  [ngClass]="
    'idp-form-alert idp-form-alert__justify-content-' + contentAlignment
  "
  (keydown)="focusOutAction($event)"
  [tabindex]="tabIndex"
  (keydown.escape)="onClosePopup()"
>
  <p *ngIf="message">
    <i
      [ngClass]="successIcon ? 'idp-icon-success' : 'idp-icon-alert'"
      aria-hidden="true"
    ></i>
    <span [innerHTML]="message"></span>
    <span *ngIf="showCloseButton">
      <button
        tabindex="1"
        aria-label="Close"
        type="button"
        class="idp-info-tooltip__wrapper--close"
        (click)="onClosePopup()"
        (keydown.enter)="onClosePopup()"
      >
        <i class="idp-close-icon"></i>
      </button>
    </span>
  </p>
  <ng-container *ngIf="alertMessages && alertMessages.length > 0">
    <section class="idp-form-alert__messages">
      <div
        *ngFor="let alertMessage of alertMessages"
        class="idp-form-alert__messages--group"
      >
        <p>
          <i
            [ngClass]="successIcon ? 'idp-icon-success' : 'idp-icon-alert'"
            aria-hidden="true"
          ></i>
          <span [innerHTML]="alertMessage"></span>
        </p>
      </div>
    </section>
  </ng-container>
</div>
